import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/img/Domain-Logo.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  class: "",
  src: _imports_0,
  alt: "logo-ixi",
  width: "",
  height: ""
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "Settings", -1)
const _hoisted_3 = { class: "grid p-fluid" }
const _hoisted_4 = { class: "col-12 md:col-12" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "api_token" }, "Api Token", -1)
const _hoisted_6 = { class: "col-12 md:col-12" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "api_token" }, "Credit score", -1)
const _hoisted_8 = { class: "col-12 md:col-12" }
const _hoisted_9 = { class: "field-checkbox" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "sign_request" }, "Sign request", -1)
const _hoisted_11 = { class: "col-12 md:col-12" }
const _hoisted_12 = { class: "grid" }
const _hoisted_13 = { class: "col-6" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "backoffice_card_type_number" }, "Backoffice kaart type nummer", -1)
const _hoisted_15 = { class: "col-6" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "webhook_url" }, "Webhook URL", -1)
const _hoisted_17 = { class: "grid" }
const _hoisted_18 = { class: "col-6" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { for: "account_number_reference" }, "Externe account referentie", -1)
const _hoisted_20 = { class: "col-6" }
const _hoisted_21 = { class: "field-checkbox" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { for: "requires_approval" }, "Handmatig goedkeuren", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PMenubar = _resolveComponent("PMenubar")!
  const _component_PInputText = _resolveComponent("PInputText")!
  const _component_PInputNumber = _resolveComponent("PInputNumber")!
  const _component_PCheckbox = _resolveComponent("PCheckbox")!
  const _component_PPanel = _resolveComponent("PPanel")!
  const _component_PButton = _resolveComponent("PButton")!
  const _component_PDialog = _resolveComponent("PDialog")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createVNode(_component_PMenubar, null, {
      start: _withCtx(() => [
        _hoisted_1
      ]),
      end: _withCtx(() => [
        _createElementVNode("i", {
          class: "pi pi-cog",
          style: {"font-size":"2rem"},
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openSettings()))
        })
      ]),
      _: 1
    }),
    _createVNode(_component_PDialog, {
      header: "Header",
      visible: _ctx.display,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.display) = $event)),
      style: {width: '50%'}
    }, {
      header: _withCtx(() => [
        _hoisted_2
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_PButton, {
          label: "Close",
          autofocus: "",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.openSettings()))
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_PInputText, {
              id: "api_token",
              modelValue: _ctx.settingsStore.apiToken,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.settingsStore.apiToken) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_PInputNumber, {
              id: "api_token",
              modelValue: _ctx.settingsStore.creditScore,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.settingsStore.creditScore) = $event)),
              mode: "decimal",
              minFractionDigits: 1,
              maxFractionDigits: 1,
              max: 10.0
            }, null, 8, ["modelValue", "max"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_PCheckbox, {
                modelValue: _ctx.settingsStore.signRequest,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.settingsStore.signRequest) = $event)),
                inputId: "sign_request",
                binary: true
              }, null, 8, ["modelValue"]),
              _hoisted_10
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_PPanel, {
              header: "Geavanceerde instellingen",
              toggleable: true,
              collapsed: true
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createVNode(_component_PInputNumber, {
                      id: "backoffice_card_type_number",
                      modelValue: _ctx.settingsStore.backoffice_card_type_number,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.settingsStore.backoffice_card_type_number) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createVNode(_component_PInputText, {
                      id: "webhook_url",
                      modelValue: _ctx.settingsStore.webhook_url,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.settingsStore.webhook_url) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createVNode(_component_PInputText, {
                      id: "account_number_reference",
                      modelValue: _ctx.settingsStore.account_number_reference,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.settingsStore.account_number_reference) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_PCheckbox, {
                        modelValue: _ctx.settingsStore.requires_approval,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.settingsStore.requires_approval) = $event)),
                        inputId: "requires_approval",
                        binary: true
                      }, null, 8, ["modelValue"]),
                      _hoisted_22
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}